// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';


import { capitalizeAll, getUsernameFromToken } from '../../../utils';

// INNER IMPORTS
import { clearPinWaiting } from "../../../Actions/users";

// svgs

import spearsBGSVG from '../../inlineSVGs/spearsBGSVG';
// styles
import './UserPanelBanner.css';
import closeCrossSVG from "../../inlineSVGs/closeCrossSVG";
import SVGInline from "react-svg-inline";
import emptyAvatarOLDSVG from "../../inlineSVGs/emptyAvatarOLDSVG";
import ProfileAvatar from "../../Users/ProfileAvatar";
import {ENROL_TYPE_FREE, ENROL_TYPE_HIGH, ENROL_TYPE_HUGE, ENROL_TYPE_MEDIUM} from "../../../Models/consts";
import {browserHistory} from "react-router";

class UserPanelBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    renderCover() {
        return(
            <div className="mugics-slide">
                <SVGInline className="spheres-bg" svg={spearsBGSVG} component="i"/>
            </div>
        )
    }

    getPlanName(enrolType) {
        switch(enrolType) {
            case ENROL_TYPE_FREE:
                return 'חינם';
            case ENROL_TYPE_MEDIUM:
                return  'חבילת מוזיקאי';
            case ENROL_TYPE_HIGH:
                return 'מוזיקאי פול טיים';
            case ENROL_TYPE_HUGE:
                return 'חבילת ביזנס';
            default:
                return 'זמני'
        }
    }

    handlePlanBadgeClick() {
        this.props.clearPinWaiting();
        browserHistory.push('/packages');
    }

    renderMobile(userName, userEmail, enrolType) {

        return (
            <div className={`user-panel-banner-wrapper mobile rtl`}>
                <div className={`type-line`}></div>

                {this.renderCover()}
            </div>
        )
    }

    renderWeb(userName, userEmail, enrolType) {
        return (
            <div className={`user-panel-banner-wrapper rtl`}>
                <ProfileAvatar />
                <div className="avatar-name">
                    <h2 className="user-name">{capitalizeAll(userName || userEmail)}</h2>
                </div>
                <div className="plan-badge-btn" onClick={() => this.handlePlanBadgeClick() }>{this.getPlanName(enrolType)}</div>
                <SVGInline className="spheres-bg" svg={spearsBGSVG} component="i"/>
            </div>
        )
    }

    render() {
        if (!this.props || !this.props.datatypes) return null;

        const { userName, userEmail } = getUsernameFromToken(this.props.token);
        return this.renderWeb(userName, userEmail, this.props.enrolType)
    }
}

UserPanelBanner.propTypes = {
    datatypes: PropTypes.object,
    filters: PropTypes.object,
    token: PropTypes.string,
    enrolType: PropTypes.string,
    clearPinWaiting: PropTypes.func
};

const mapStateToProps = state => ({
    datatypes: state.main.datatypes,
    filters: state.main.filters,
    token: state.users.token,
    enrolType: state.users.subscription && state.users.subscription.enrolType
});

export default connect(mapStateToProps, {
    clearPinWaiting
})(UserPanelBanner);



// WEBPACK FOOTER //
// ./src/Components/ScreenElements/Banners/UserPanelBanner.js